document.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll('.how-it-works').forEach(function(howItWorksSection) {
        const tabs = howItWorksSection.querySelectorAll('.how-it-works__tabs__item');
        const images = howItWorksSection.querySelectorAll('.how-it-works__image');
        let currentTab = 0; // Track the currently active tab
        let autoSwitchInterval; // Store the interval ID

        // Function to switch tabs
        function switchTab(index) {
            tabs.forEach(function(item, i) {
                item.classList.toggle('active', i === index);
            });
            images.forEach(function(image, i) {
                image.classList.toggle('active', i === index);
            });
        }

        // Function to start the auto-switch interval
        function startAutoSwitch() {
            autoSwitchInterval = setInterval(function() {
                currentTab = (currentTab + 1) % tabs.length;
                switchTab(currentTab);
            }, 3000);
        }

        // Function to reset the auto-switch interval on click
        function resetAutoSwitch() {
            clearInterval(autoSwitchInterval); // Stop the current interval
            startAutoSwitch(); // Start a new interval
        }

        // Add click event listeners to the tabs
        tabs.forEach(function(tabItem, index) {
            tabItem.addEventListener('click', function(event) {
                event.preventDefault();
                currentTab = index;
                switchTab(currentTab);
                resetAutoSwitch(); // Reset the interval after a manual tab click
            });
        });

        // Start the initial auto-switch interval
        startAutoSwitch();
    });
});